import { mapCollection } from '../../utils/collection.utils';
import { parseNumber } from '../../utils/number.utils';
import { MaintenanceTask } from '../maintenance-task';

export class MaintenanceTaskBuilder {
  static fromJson(json) {
    return (json)
      ? new MaintenanceTask(
        json.hash,
        parseNumber(json.startDate),
        parseNumber(json.endDate),
        json.observation,
        json.notify,
        json.realized,
        json.configurationName,
        json.configurationFrequency,
        json.hasPdfs
      )
      : null;
  }

  static fromList(list) {
    return mapCollection(MaintenanceTaskBuilder.fromJson, list);
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/maintenance-task.builder.ts